import { render, staticRenderFns } from "./BasicFileInput.vue?vue&type=template&id=32da487e&scoped=true"
import script from "./BasicFileInput.vue?vue&type=script&lang=js"
export * from "./BasicFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32da487e",
  null
  
)

export default component.exports